// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_eW","advertDetailContactItem__link":"c-n_eX"};